import { WalletTransactionStatus } from '../../../core/enum/mysec/wallet-transaction-status.enum';
import { WalletTransactionEvent } from '../../../core/enum/mysec/wallet-transaction-event.enum';

export class WalletTransactionFilter {
  take: number;
  currentPage: number;
  orderBy: string;
  isOrderByDesc: boolean;
  walletTransactionStatuses: WalletTransactionStatus[];
  walletTransactionEvents: WalletTransactionEvent[];

  constructor() {
    this.take = 12;
    this.currentPage = 1;
    this.orderBy = 'CreatedAt';
    this.isOrderByDesc = true;
    this.walletTransactionStatuses = [WalletTransactionStatus.All];
    this.walletTransactionEvents = [WalletTransactionEvent.All];
  }
}
